// extracted by mini-css-extract-plugin
export default {"form":"ConnectAmazonMcfForm_form__joJTP","body":"ConnectAmazonMcfForm_body__w3i8D","footer":"ConnectAmazonMcfForm_footer__Vg4sK","button":"ConnectAmazonMcfForm_button__95Wu4"};